import {api} from '../../api/access-ctrl'
import {
  registerConfig, ROUTE_NAME_OF_DI_PAGE
} from '../../../components/common/di-ding'
import {commonConfig, routeNameOfDi} from '../common'
import Vue from 'vue'
import ButtonDelete from '../../../components/common/buttons/button-delete'
import ButtonAuth from '../../../components/common/buttons/button-auth'
import ButtonAuthNew from '../../../components/common/buttons/button-auth-new'
import {nTipFunc, nWarn} from '../../../utils/notice'
import {errorHandler} from '../../../utils/errorHandler'

Vue.component('button-delete', ButtonDelete)
Vue.component('button-auth', ButtonAuth)
Vue.component('button-auth-new', ButtonAuthNew)

export const mapping = {
  personName: '姓名',
  phone: '手机号码',
  enterpriseName: '所属住户',
  deviceName: {
    label: '门禁'
  },
  yqPicStatus: {
    label: '照片下发状态',
    type: 'fontStatus',
    width: '220',
    mapList: {
      map: {
        '0': '成功',
        '1': '图片中未检测到人脸',
        '2': '图片中检测到多张脸',
        '3': '扩大的人脸框越界',
        '4': '68点人脸区域过小',
        '5': '68点角度过大',
        '6': '光照检测未通过',
        '7': '模糊度检测未通过',
        '8': '阴阳脸检测未通过',
      }
    }
  }
}

const config = {
  breadcrumb: [{
    value: '智慧门禁',
    name: 'accessCtrlDeviceManagementCenter'
  }, {
    value: '门禁授权',
  }],
  center: {
    searchTree: {
      searchKey: 'deviceId',
      searchType: 'face'
    },
    opBar: [ // 多少个元素代表多少行
      [ // 仅支持 flex布局
        // {
        //   type: 'search-tree',
        //   label: '设备名称',
        //   searchKey: 'departmentId',
        //   fetchDetail: () => Promise.resolve([])
        //     .then(list => {
        //       list.forEach(it => {
        //         it._value = it.id
        //         it._label = it.name
        //       })
        //       return list
        //     })
        // },
        {
          type: 'search-selector',
          label: '所属住户',
          searchKey: 'enterpriseCode',
          fetchDetail: () => api.getEnterpriseInfoList()
            .then(list => {
              list.forEach(it => {
                it._value = it.code
                it._label = it.enterpriseName
              })
              return list
            })
        },
        {type: 'input-search', label: '姓名/手机号码/所属住户', searchKey: 'searchKey'}
      ],
      [
        {
          type: 'render',
          renderContent (h, type, data, that) {
            return <button-auth-new
              value="添加授权"
              deviceUse="1"
              onthis={that}
              iconClassName="el-icon-minus"
            />
          }
        },
        {
          type: 'render',
          renderContent (h, type, data, that) {
            const handleClick = () => {
              // let devType = window.sessionStorage.getItem('devType')
              // if (!devType) {
              //   nWarn('请先选择需要解绑的设备')
              //   return
              // }
              if (that.selected.length === 0) {
                nWarn('请先选择需要解绑的对象')
                return
              }
              that.$confirm('确认解绑？')
                .then(
                  () => {
                    let ids = that.selected.map(s => s.code).join(',')
                    let resData = []
                    resData = ids.split(',')
                    api.deleteAuthority(resData)
                      .then(nTipFunc('解绑成功'))
                      .then(() => {
                        that.getData()
                      })
                  },
                  () => {
                    console.debug('用户取消了解绑')
                  }
                )
                .catch(errorHandler('请求失败'))
            }
            return <button-delete
              value="删除授权"
              onClick={handleClick}
              iconClassName="el-icon-minus"
            />
          }
        },
        {
          type: 'button-cancel',
          label: '查看住户',
          onClick () {
            this.routerPush(ROUTE_NAME_OF_DI_PAGE.CENTER, {diName: routeNameOfDi.APP_CENTER_ACCESS_CTRL_FACE_AUTHORITY_ENTERPRISE})
          }
        },
        {
          type: 'button-download',
          label: '导出',
          getDownloadUrl: (requestBody) => api.exportAuthorityInfo(requestBody),
          download: '授权列表'
        }
      ]
    ],
    table: {
      selectBox: true,
      operations: [{
        renderContent (h, pageType, data, vm) {
          const handleDelete = () => {
            let sendData = []
            sendData.push(data.code)
            vm.$confirm('确认删除？')
              .then(
                () =>
                  api.deleteAuthority(sendData)
                    .then(nTipFunc('删除成功'))
                    .then(vm.getData)
                ,
                () => {
                  console.debug('用户取消了删除')
                }
              )
              .catch(errorHandler('请求失败'))
          }
          return <a onClick={handleDelete}>删除授权</a>
        }
      }]
    }
  },

  get: requestBody => api.getAuthority(requestBody),
  delete: strId => api.deleteAuthority(strId),

  mapping
}

registerConfig(routeNameOfDi.APP_CENTER_ACCESS_CTRL_FACE_AUTHORITY, config)



// WEBPACK FOOTER //
// ./src/view/AccessCtrl/authority/face-authority.js